var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":(_vm.url + "/bi-link/EmbeddedDossier.html?token=" + _vm.token + "&url=" + _vm.url),"title":"control-panel-iframe"}})])}
var staticRenderFns = []

export { render, staticRenderFns }